import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';

import { Notification } from 'app/_models/notification';
import { Shipowner } from 'app/_models/shipowner';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class NotificationService extends ApiService {
  constructor(private http: Http) {
    super('api/notifications/', http);
  }

  getNotification(id: number): Observable<Notification> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}${id}/`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  create(): Observable<Notification> {
    return this.http
      .post(this.apiUrl + this.endpointUrl, {}, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(notification: Notification): Observable<Notification> {
    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/`;
    return this.http.put(url, notification.serialize(), { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  delete(id: number): Observable<void> {
    const url = `${this.apiUrl + this.endpointUrl}${id}/`;
    return this.http.delete(url, { headers: this.getHeaders() }).catch(this.handleError);
  }

  send(notification: Notification): Observable<Notification> {
    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/send/`;
    return this.http.post(url, { platform: 'deo' }, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  attachShipowner(notification: Notification, shipowner: Shipowner, method = 'add'): Observable<Notification> {
    const slug = method === 'add' ? 'add_recipient' : 'remove_recipient';
    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/${slug}/`;
    return this.http.post(url, { recipient: shipowner.id }, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  attachByShiptype(notification: Notification, type: string): Observable<Notification> {
    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/add_shiptype_recipients/`;
    return this.http.post(url, { shiptype: type }, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  attachAll(notification: Notification, method = 'add'): Observable<Notification> {
    const slug = method === 'add' ? 'add_all_recipients' : 'remove_all_recipients';
    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/${slug}/`;
    return this.http.post(url, {}, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  attachmentFile(notification: Notification, file: File): Observable<Notification> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('notification_id', String(notification.id));

    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/upload_attachment_file/`;
    return this.http
      .post(url, formData, { headers: this.getHeaders(false) })
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeAttachmentFile(notification: Notification, id_file): Observable<Notification> {
    const formData = new FormData();
    formData.append('id_file', id_file);
    formData.append('notification_id', String(notification.id));

    const url = `${this.apiUrl + this.endpointUrl}${notification.id}/remove_attachment_file/`;
    return this.http
      .post(url, formData, { headers: this.getHeaders(false) })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/notification.service.ts